/* ============================================================
   SORA — Couche CRO
   Compte a rebours reel, sticky add to cart, reveals au scroll,
   jauge de stock. Aucune dependance.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Compte a rebours ------------------------------------
     La date de fin est FIXE et definie dans l'editeur de theme.
     Elle ne se reinitialise jamais d'une visite a l'autre : un
     compte a rebours qui redemarre pour chaque visiteur est une
     pratique commerciale trompeuse (directive Omnibus, UE).
     Si la date est absente, invalide ou depassee, le bloc reste
     masque et l'offre disparait proprement.
  ------------------------------------------------------------------- */
  function initCountdown(el) {
    var raw = el.getAttribute('data-cro-end');
    if (!raw) return;

    var end = new Date(raw.replace(' ', 'T'));
    if (isNaN(end.getTime())) return;

    var units = {
      d: el.querySelector('[data-cro-d]'),
      h: el.querySelector('[data-cro-h]'),
      m: el.querySelector('[data-cro-m]'),
      s: el.querySelector('[data-cro-s]')
    };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) {
        el.classList.remove('is-live');
        // L'offre est terminee : on retire aussi les mentions liees.
        document.querySelectorAll('[data-cro-offer]').forEach(function (n) {
          n.style.display = 'none';
        });
        clearInterval(timer);
        return;
      }
      var sec = Math.floor(left / 1000);
      if (units.d) units.d.textContent = pad(Math.floor(sec / 86400));
      if (units.h) units.h.textContent = pad(Math.floor(sec % 86400 / 3600));
      if (units.m) units.m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (units.s) units.s.textContent = pad(sec % 60);
      el.classList.add('is-live');
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ---------- 2. Jauge de stock -------------------------------------
     Alimentee par l'inventaire reel de Shopify. Si le suivi des
     stocks n'est pas active, le bloc n'est pas rendu cote Liquid.
  ------------------------------------------------------------------- */
  function initStock() {
    document.querySelectorAll('[data-cro-stock-fill]').forEach(function (bar) {
      var pct = parseFloat(bar.getAttribute('data-cro-stock-fill'));
      if (isNaN(pct)) return;
      pct = Math.max(6, Math.min(100, pct));
      if (reduced) { bar.style.width = pct + '%'; return; }
      requestAnimationFrame(function () {
        setTimeout(function () { bar.style.width = pct + '%'; }, 220);
      });
    });
  }

  /* ---------- 3. Reveals au scroll ----------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.cro-fade');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. Sticky add to cart (mobile) -------------------------
     Ne duplique pas la logique panier : la barre reflete l'etat du
     vrai bouton et lui delegue le clic. Si aucune taille n'est
     choisie, elle ramene le visiteur au selecteur.
  ------------------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.getElementById('soraStickyAtc');
    if (!bar) return;

    var sourceId = bar.getAttribute('data-cro-source');
    var anchorId = bar.getAttribute('data-cro-anchor');
    var source = sourceId ? document.getElementById(sourceId) : null;
    var anchor = anchorId ? document.getElementById(anchorId) : null;
    if (!source) { bar.remove(); return; }

    var btn = bar.querySelector('button');
    var priceOut = bar.querySelector('[data-cro-sticky-price]');
    var livePrice = document.getElementById('buyPrice') || document.getElementById('soraPrice');

    function sync() {
      if (!btn) return;
      var label = (source.textContent || '').trim();
      btn.disabled = !!source.disabled;
      btn.textContent = source.disabled && /talla/i.test(label) ? 'Elegir talla' : (label || 'Añadir al carrito');
      if (priceOut && livePrice) {
        var p = (livePrice.textContent || '').trim();
        if (p) priceOut.textContent = p;
      }
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (source.disabled) {
          var target = anchor || source;
          target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        source.click();
      });
    }

    // On suit les changements d'etat du bouton reel (libelle + disabled).
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(source, {
        attributes: true, childList: true, characterData: true, subtree: true
      });
    }
    document.addEventListener('click', function () { setTimeout(sync, 60); }, true);
    sync();

    // Visibilite : la barre apparait une fois le declencheur depasse,
    // et s'efface des que le vrai bouton revient a l'ecran (pour ne
    // jamais le recouvrir).
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }

    var afterId = bar.getAttribute('data-cro-reveal-after');
    var trigger = (afterId && document.getElementById(afterId)) || source;
    var passedTrigger = false;
    var sourceVisible = true;

    function apply() {
      bar.classList.toggle('is-visible', passedTrigger && !sourceVisible);
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        passedTrigger = !e.isIntersecting && e.boundingClientRect.top < 0;
        apply();
      });
    }, { threshold: 0 }).observe(trigger);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sourceVisible = e.isIntersecting;
        apply();
      });
    }, { threshold: 0 }).observe(source);
  }

  function boot() {
    document.querySelectorAll('[data-cro-end]').forEach(initCountdown);
    initStock();
    initReveals();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
